/** Menu-share readiness: a menu is worth texting to a buyer once it holds this many live listings. */
export const SHARE_READY_MIN = 5;

export const isShareReady = (count: number) => count >= SHARE_READY_MIN;

/** Encouragement line while a menu is still filling up; null once it's ready. */
export function shareReadyLine(count: number): string | null {
  if (isShareReady(count)) return null;
  const n = Math.max(0, count);
  if (n === 0) return `Add a listing to your menu, then share it. Menus with ${SHARE_READY_MIN}+ listings get more opens.`;
  return `Share now, or add a few more listings first. Menus with ${SHARE_READY_MIN}+ listings get more opens.`;
}

/** Ready-made messages in the seller's own voice. The link is appended separately. */
export function shareTemplates(menuName: string, count: number): { id: string; label: string; text: string }[] {
  return [
    { id: 'fresh', label: 'VIP Drop', text: `Hey, putting this in front of you first before it moves. Here’s our live menu with photos and wholesale pricing: [link]. Hit me back if you want to lock anything in or grab samples.` },
    { id: 'checkin', label: 'Quick Check-In', text: `Hey, thought of you — here’s what we’ve got in play today: [link]. Anything catch your eye?` },
    { id: 'short', label: 'Short & Punchy', text: `Live menu with photos and pricing: [link]. Let me know what you need.` },
  ];
}

const LINK_TOKEN = /\[(?:link|url|menu link)\]/gi;

/** Swap any link token for the real URL so the editor shows exactly what is sent. */
export function resolveShareLink(message: string, url: string): string {
  if (!url) return message;
  return message.replace(LINK_TOKEN, url);
}

/** Insert the link once (case-insensitive token), or append it when absent. */
export function menuShareMessage(message: string, url: string): string {
  const resolved = resolveShareLink(message, url);
  if (!url || resolved.includes(url)) return resolved;
  return `${resolved}\n\n${url}`;
}
